export const selectSearchData =
  (key) =>
  ({ searchData }) =>
    searchData[key] || {};
